import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiRocket, FiClock, FiTarget, FiTrendingUp } = FiIcons;

const FinalCTASection = () => {
  return (
    <section className="final-cta-section py-20 px-4 bg-gradient-to-br from-gray-900 via-blue-900 to-black text-white">
      <div className="max-w-6xl mx-auto">
        <motion.div 
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-6xl font-bold mb-6">
            Ready to Build Your Own <span className="text-yellow-400">AI Software Company?</span>
          </h2>
        </motion.div>

        <motion.div 
          className="summary-grid grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="summary-card bg-white/10 backdrop-blur-lg p-6 rounded-xl border border-white/20 text-center">
            <SafeIcon icon={FiRocket} className="text-3xl text-blue-400 mx-auto mb-3" />
            <h3 className="font-bold text-lg mb-2">7 Days</h3>
            <p className="text-gray-300 text-sm">To Launch</p>
          </div>
          
          <div className="summary-card bg-white/10 backdrop-blur-lg p-6 rounded-xl border border-white/20 text-center">
            <SafeIcon icon={FiTrendingUp} className="text-3xl text-green-400 mx-auto mb-3" />
            <h3 className="font-bold text-lg mb-2">₹1 Crore+</h3>
            <p className="text-gray-300 text-sm">Annual Potential</p>
          </div>
          
          <div className="summary-card bg-white/10 backdrop-blur-lg p-6 rounded-xl border border-white/20 text-center">
            <SafeIcon icon={FiTarget} className="text-3xl text-purple-400 mx-auto mb-3" />
            <h3 className="font-bold text-lg mb-2">Personal</h3>
            <p className="text-gray-300 text-sm">Mentorship</p>
          </div>
          
          <div className="summary-card bg-white/10 backdrop-blur-lg p-6 rounded-xl border border-white/20 text-center">
            <SafeIcon icon={FiClock} className="text-3xl text-red-400 mx-auto mb-3" />
            <h3 className="font-bold text-lg mb-2">4 Seats</h3>
            <p className="text-gray-300 text-sm">Left This Month</p>
          </div>
        </motion.div>

        <motion.div 
          className="final-summary bg-white/5 backdrop-blur-lg p-8 rounded-2xl border border-white/20 mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <p className="text-xl text-center leading-relaxed text-gray-200">
            This is your chance to break free from the cycle of trading time for money and build a 
            <span className="font-bold text-yellow-400"> predictable, scalable software business</span> that generates 
            <span className="font-bold text-green-400"> recurring income every month</span>. With Abdul's personal guidance, 
            proven systems, and step-by-step implementation, you can launch your AI software company in just 7 days.
          </p>
        </motion.div>

        <motion.div 
          className="urgency-scarcity bg-gradient-to-r from-red-500/20 to-orange-500/20 p-6 rounded-xl border border-red-500/30 mb-12"
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <div className="text-center">
            <p className="text-red-300 font-semibold text-lg mb-2">⚠️ Limited Time & Seats Available</p>
            <p className="text-white">Only 5 seats per month. 1 taken, 4 left. Next batch starts in 30 days.</p>
          </div>
        </motion.div>

        <motion.div 
          className="text-center"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.8 }}
          viewport={{ once: true }}
        >
          <motion.a
            href="https://abdul.cc/earnwithabdul"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-yellow-400 to-yellow-600 text-black font-bold text-2xl px-16 py-8 rounded-full hover:from-yellow-500 hover:to-yellow-700 transition-all duration-300 transform hover:scale-105 shadow-2xl mb-6"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Apply Now & Get Your 1 Crore Game Plan
          </motion.a>
          
          <div className="bg-white/10 backdrop-blur-lg p-6 rounded-xl border border-white/20 max-w-2xl mx-auto">
            <p className="text-lg text-gray-200 leading-relaxed">
              During the call, you'll receive your <span className="font-bold text-yellow-400">1 Crore Game Plan</span> and 
              <span className="font-bold text-green-400"> Immediate Execution Strategies</span> to launch your own software company 
              within the next 7 days — personally guided by <span className="font-bold text-blue-400">Abdul Hakkim A</span>.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;